import {Typography} from '@mui/material';
import React from 'react';

import {Row, StyledCard} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {usePersonalData} from 'presentation/hooks';
import {formatMasks} from 'presentation/utils';

const {title, cellphone, email} =
	translations['pt-br'].privateFlow.refund.conferencePage.contactInfo;

export const ContactInfoCardTherapies = () => {
	const {currentEmail, currentPhone} = usePersonalData();

	return (
		<StyledCard.Container>
			<Typography fontWeight={600} variant="subtitle2" color={'text.secondary'}>
				{title}
			</Typography>

			<Row.Compound
				items={[
					{
						title: cellphone,
						value: formatMasks('phone', currentPhone),
					},
					{
						title: email,
						value: currentEmail,
					},
				]}
				hiddenDivider
			/>
		</StyledCard.Container>
	);
};
